<div *ngIf="header.field == 'analysis'">
    <!-- <a class="underlined-link" (click)="showMore(data)">Click to Know More</a> -->
     <mat-icon (click)="showMore(data)"> insert_chart</mat-icon>
  </div>
